import { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

// Internal links go through the router so the page doesn't reload; external
// links open in a new tab.
const MarkdownLink = ({ node, href = '', children, ...props }: any) => {
    if (href.startsWith('/')) {
        return <Link to={href}>{children}</Link>;
    }
    if (href.startsWith('#')) {
        return <a href={href} {...props}>{children}</a>;
    }
    return <a href={href} target="_blank" rel="noreferrer" {...props}>{children}</a>;
};

const Markdown = ({ content }: { content: string }) => {
    const ref = useRef<HTMLElement>(null);

    // Start each new page at the top. Wide screens scroll this element; narrow
    // screens scroll the window.
    useEffect(() => {
        ref.current?.scrollTo(0, 0);
        window.scrollTo(0, 0);
    }, [content]);

    return (
        <article ref={ref} className={`flex-1 min-w-0 md:overflow-y-auto no-scrollbar md:pb-12`}>
            <div className={`prose prose-site prose-lg lg:prose-xl max-w-[68ch] font-garamond leading-[1.65] lg:leading-[1.65] break-words prose-pre:px-4 prose-pre:leading-[1.55] lg:prose-pre:leading-[1.55] prose-h1:text-[2.1em] lg:prose-h1:text-[2.4em] prose-h1:mb-[0.6em]`}>
                <ReactMarkdown remarkPlugins={[remarkGfm]} components={{ a: MarkdownLink }}>{content}</ReactMarkdown>
            </div>
        </article>
    );
};

export default Markdown;
